module.exports = __webpack_public_path__ + "static/media/redpayments.cd1dcfb6.svg";